<template lang="pug">
	.v-image-slider.image-slider(:class="['image-slider--' + mode, {'loading': loading, 'image-slider--full': slider && slider.items && slider.items.length > 1}]")
		.image-slider__slider(v-if="slider && slider.items && slider.items.length")
			template(v-if="slider.button" )
				button.image-slider__gallery-btn(type="button" @click="closeGallery" v-if="mode === 'regular' && slider.button.close" :aria-label="slider.button.close?.ariaLabel")
					v-svg-icon.image-slider__gallery-icon(:icon="slider.button.close.icon")
			.image-slider__slider-counter(v-if="slider.icons" )
				v-svg-icon.image-slider__slider-counter-icon(:icon="slider.icons?.camera")
				.image-slider__slider-counter-text {{ slidesCounter }}
			.image-slider__arrow.image-slider__arrow--prev(ref="prev")
				v-svg-icon.image-slider__arrow-icon(icon="slide-left")
			.image-slider__arrow.image-slider__arrow--next(ref="next")
				v-svg-icon.image-slider__arrow-icon(icon="slide-right")
			.image-slider__sliders
				v-swiper-slider.image-slider__main-slider(v-if="slider && slider.items && slider.items.length"
					:options="options"
					:navigation="navigation"
					:pagination="pagination"
					@slide-change="onSlideChange"
					@swiper="onSwiper")
					template(v-for="(slide, index) in slider.items" :key="index")
						v-swiper-slide
							.image-slider__item
								template(v-if="slide.type === 'video'")
									.image-slider__iframe-wrap
										v-video.image-slider__video(:type="slide.type" :src="slide.link" :poster="slide.link")
								template(v-else-if="slide.type === 'youtube'" )
									.image-slider__iframe-wrap
										v-video.image-slider__video(:type="slide.type" :src="slide.link" :poster="slide.src")
								template(v-else)
									img.image-slider__image(:src="slide.src" :alt="slide.alt")
				v-swiper-slider.image-slider__thumps-slider(v-if="slider && slider.items && slider.items.length"
					:options="thumpsOptions"
					:navigation="navigationThumbs"
					:direction="direction"
					:virtualIndex="initialIndex"
					@swiper="onSwiperThumbs")
					template(v-for="(slide, index) in slider.items" :key="index")
						v-swiper-slide(@click="slideToIndex(index)")
							.image-slider__thumbs
								template(v-if="slide.type === 'video'")
									video.image-slider__thumb(:src="slide.link" :alt="slide.alt")
									.video__btn
										v-svg-icon.video__btn-icon(icon="play-btn")
								template(v-else-if="slide.type === 'youtube'")
									img.image-slider__thumb(:src="slide.src" :alt="slide.alt")
									.video__btn
										v-svg-icon.video__btn-icon(icon="play-btn")
								template(v-else)
									img.image-slider__thumb(:src="slide.src" :alt="slide.alt")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import uniqueId from '../scripts/helpers/uniqueId';
import {SwiperSlide} from 'swiper/vue';
import breakpoints from '../scripts/breakpoints';
import controller from '../scripts/controller/controller';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';

export default {
	components: {
		'v-swiper-slide': SwiperSlide
	},

	mixins: [
		sourceMixin,
		isMobMixin
	],

	emits: [
		'close-gallery'
	],

	props: {
		mode: {
			type: String,
			default: 'regular'
		},

		title: {
			type: String,
			default: null
		},

		initialIndex: {
			type: Number,
			default: 0
		}
	},

	data() {
		return {
			slider: {},
			uniqueId: uniqueId('swiper-'),
			newOptions: null,
			isMdTimeout: null,
			thumbsSwiper: null,
			mainSwiper: null,
			activeIndex: 0,
			options: {
				slidesPerView: 1,
				loop: false,
				initialSlide: this.initialIndex,
				breakpoints: {
					// when window width is >= x
					[breakpoints['xl-min']]: {
						spaceBetween: 4
					},
					[breakpoints['lg-min']]: {
						spaceBetween: 4
					},
					[breakpoints['sm-min']]: {
						spaceBetween: 4
					}
				}
			},
			thumpsOptions: {
				slidesPerView: 'auto',
				// watchOverflow: true,
				breakpoints: {
					[breakpoints['md-min']]: {
					},
					[breakpoints['lg-min']]: {
						slidesPerView: 'auto',
					},
					[breakpoints['xs-min']]: {
						slidesPerView: 'auto',
					},
					[breakpoints['3xs-min']]: {
						slidesPerView: 'auto',
					},
					[breakpoints['4xs-min']]: {
						slidesPerView: 'auto',
					},
				}
			},
			navigation: false,
			navigationThumbs: false,
			pagination: {
				clickable: true,
			},
			direction: 'horizontal'
		};
	},

	methods: {
		onSwiper(slider) {
			this.mainSwiper = slider;
			this.navigation = {
				prevEl: this.$refs['prev'],
				nextEl: this.$refs['next']
			}
		},

		onSwiperThumbs(slider) {
			this.thumbsSwiper = slider;
		},

		onSlideChange(slider) {
			if(!this.thumbsSwiper || !slider) return;
			this.activeIndex = slider.realIndex;
			this.thumbsSwiper.slideTo(slider.realIndex);
		},

		slideToIndex(index) {
			this.activeIndex = index;
			this.mainSwiper.slideTo(index);
		},

		closeGallery() {
			this.$emit('close-gallery')
		},

		dataSet(data) {
			this.slider = data;
			this.uniqueId = uniqueId('swiper-');
		}
	},

	watch: {
		thumbsSwiper() {
			this.onSlideChange()
		}
	},
	computed: {
		slidesCounter() {
			return `${this.activeIndex + 1}/${this.slider.items.length}`
		}
	}
};
</script>